import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Icon = ({ icon }: { icon: any }) => <FontAwesomeIcon icon={icon} />;

export default Icon;
